import Vue from 'vue';
import Vuex, { ActionContext, Module } from 'vuex';
import ConfigState from './configState';
import VueApp, { bus } from '@/main';

import { RootState } from '@/store/rootState';
import { AxiosResponse, AxiosError } from 'axios';
import { OrchestrationRouteModel } from '@/models/orchestrationRouteModel';
import Workflow from '@/models/workflow';

Vue.use(Vuex);

export const configStore: Module<ConfigState, RootState> = {
  namespaced: true,
  state: new ConfigState(),
  mutations: {
    updateWorkflows(state: ConfigState, workflows: Workflow[]): void {
      Vue.set(state, 'workflows', workflows);
    },
    updateOrchestrationRoutes(state: ConfigState, orchestrationRoutes: OrchestrationRouteModel[]): void {
      Vue.set(state, 'orchestrationRouteModels', orchestrationRoutes);
    },
  },
  actions: {
    async getWorkflows({ commit }: ActionContext<ConfigState, RootState>, callback?: () => void): Promise<void> {
      if (VueApp) {
        VueApp.$http
          .get<never>('workflow')
          .then((result: AxiosResponse<Workflow[]>) => {
            commit('updateWorkflows', result.data);

            if (callback) {
              callback();
            }
          })
          .catch((error: AxiosError) => {
            bus.$emit('alert', 'Get workflows failed ', 'error', 6000, error);
          });
      }
    },

    async getOrchestrationRouteModels(
      { commit }: ActionContext<ConfigState, RootState>,
      callback?: () => void,
    ): Promise<void> {
      if (VueApp) {
        VueApp.$http
          .get<never>('orchestrationRoute')
          .then((result: AxiosResponse<OrchestrationRouteModel[]>) => {
            commit('updateOrchestrationRoutes', result.data);

            if (callback) {
              callback();
            }
          })
          .catch((error: AxiosError) => {
            bus.$emit('alert', 'Get orchestration routes failed ', 'error', 6000, error);
          });
      }
    },
  },
};
